// extracted by mini-css-extract-plugin
module.exports = {"story-table-element":"_1cTy9","table-element-header":"_2rIz3","table-element-cell":"_1UTwu","table-header-cell":"_1Dex_","table-element-row":"_1k1HO"};